'use client';

import { type Table } from '@tanstack/react-table';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { UpsellItem } from '@/lib/api/upsells';

interface UpsellsTableActionsProps {
    table: Table<UpsellItem>;
    onRefresh: () => void;
    isLoading: boolean;
    storeId: string;
}

/**
 * UpsellsTableActions component for table toolbar actions
 */
export const UpsellsTableActions = ({ table, onRefresh, isLoading, storeId }: UpsellsTableActionsProps) => {
    const { t } = useTranslation('upsells');
    return (
        <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
                <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                {t('actions.refresh')}
            </Button>
        </div>
    );
};
